import { render, staticRenderFns } from "./AthleteModal.vue?vue&type=template&id=821bda16&scoped=true"
import script from "./AthleteModal.vue?vue&type=script&lang=js"
export * from "./AthleteModal.vue?vue&type=script&lang=js"
import style0 from "./AthleteModal.vue?vue&type=style&index=0&id=821bda16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821bda16",
  null
  
)

export default component.exports